const AccountDetail = () => import('@/views/account/Detail')
const AccountDaily = () => import('@/views/account/Daily')
const AccountSummary = () => import('@/views/account/Summary')
const AccountSettlement = () => import('@/views/account/Settlement')
export const account = [
  {
    path: '/account/detail',
    name: '交易明细',
    component: AccountDetail,
    meta: {
      requireAuth: true,
      title: '交易明细'
    }
  },
  {
    path: '/account/daily',
    name: '交易日报',
    component: AccountDaily,
    meta: {
      requireAuth: true,
      title: '交易日报'
    }
  },
  {
    path: '/account/summary',
    name: '交易汇总',
    component: AccountSummary,
    meta: {
      requireAuth: true,
      title: '交易汇总'
    }
  },
  {
    path: '/account/settlement',
    name: '结算查询',
    component: AccountSettlement,
    meta: {
      requireAuth: true,
      title: '结算查询'
    }
  },
];



// WEBPACK FOOTER //
// ./src/router/account.route.js